import React, { useEffect } from 'react';
import styled from 'styled-components';
import AOS from 'aos';
import 'aos/dist/aos.css';

const AboutUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <Wrapper>
      <Header data-aos="fade-down">
        <LogoTitle>Welcome to <span>Totomart</span></LogoTitle>
        <Tagline>
          Powered by Ligiotech Solutions Pvt Ltd – A Smarter, Broker-Free Way to Rent, Buy, or Sell Property in India.
        </Tagline>
      </Header>

      <ContentSection data-aos="fade-up">
        <h2>Who We Are</h2>
        <p>
          Totomart is an AI-powered proptech platform redefining the way Indians discover, rent, and manage homes. As a brand built by Ligiotech Solutions Pvt Ltd, our mission is to eliminate brokerage, bring transparency, and make real estate decisions simpler, faster, and more affordable.
        </p>
        <p>
          From verified property listings to seamless online rent payments and digital rental agreements — Totomart is your one-stop solution for all things property.
        </p>
      </ContentSection>

      <ContentSection data-aos="fade-up">
        <h2>Our Mission</h2>
        <p>
          To revolutionize Indian real estate by empowering users with technology that enables direct, trustworthy, and commission-free transactions.
        </p>
      </ContentSection>

      <ContentSection data-aos="fade-up">
        <h2>Our Vision</h2>
        <p>
          We envision a future where every property transaction is seamless, digital, and accessible without hidden costs or middlemen — across cities, towns, and beyond.
        </p>
      </ContentSection>

      <ContentSection data-aos="fade-up">
        <h2>Why Choose Totomart?</h2>
        <List>
          <li>Zero Brokerage Fees – Save up to ₹50,000 per rental</li>
          <li>Verified Listings with Owner Direct Contact</li>
          <li>Smart Matchmaking Based on Location & Budget</li>
          <li>Online Rent Agreements & e-Signatures</li>
          <li>Rental Payments, Receipts, and Reminders – All in One Place</li>
          <li>24/7 Customer Support, Pan-India Coverage</li>
        </List>
      </ContentSection>

      <ContentSection data-aos="fade-up">
        <h2>About Ligiotech Solutions Pvt Ltd</h2>
        <p>
          Totomart is backed by Ligiotech Solutions Pvt Ltd (CIN: U62011TN2023PTC158693), a Chennai-based technology company building next-gen solutions for real estate, finance, and logistics. Ligiotech specializes in cloud architecture, secure fintech platforms, and enterprise SaaS.
        </p>
      </ContentSection>

      <CTA data-aos="zoom-in">
        <h3>Looking to Rent or List a Property?</h3>
        <p>Join 10,000+ users switching to a smarter way to handle real estate. No middlemen. No headaches.</p>
        <a href="/signup">Get Started →</a>
      </CTA>
    </Wrapper>
  );
};

export default AboutUs;

// Styled Components
const Wrapper = styled.div`
  max-width: 1000px;
  margin: auto;
  padding: 3rem 1.5rem;
  font-family: 'Segoe UI', sans-serif;
  color: #333;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 3rem;
`;

const LogoTitle = styled.h1`
  font-size: 2.8rem;
  color: #e53935;

  span {
    color: #b71c1c;
    font-weight: 700;
  }
`;

const Tagline = styled.p`
  font-size: 1.1rem;
  color: #555;
  margin-top: 0.5rem;
`;

const ContentSection = styled.section`
  margin-bottom: 2.5rem;

  h2 {
    color: #b71c1c;
    font-size: 1.8rem;
    margin-bottom: 0.6rem;
  }

  p {
    font-size: 1rem;
    line-height: 1.7;
    color: #444;
  }
`;

const List = styled.ul`
  margin-top: 1rem;
  padding-left: 1.2rem;

  li {
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 0.6rem;
    color: #333;
    position: relative;

    &::before {
      content: "✓";
      color: #e53935;
      margin-right: 8px;
    }
  }
`;

const CTA = styled.div`
  text-align: center;
  background: #ffecec;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(229, 57, 53, 0.1);

  h3 {
    font-size: 1.5rem;
    color: #b71c1c;
    margin-bottom: 0.8rem;
  }

  p {
    font-size: 1rem;
    color: #444;
    margin-bottom: 1rem;
  }

  a {
    display: inline-block;
    padding: 0.6rem 1.2rem;
    background: #e53935;
    color: white;
    text-decoration: none;
    border-radius: 6px;
    font-weight: 600;

    &:hover {
      background: #b71c1c;
    }
  }
`;
